export default __webpack_public_path__ + "static/media/sad.9377a05f.svg";